import { render } from "./building_works.vue?vue&type=template&id=7c654cdc&scoped=true"
import script from "./building_works.vue?vue&type=script&lang=js"
export * from "./building_works.vue?vue&type=script&lang=js"

import "./building_works.vue?vue&type=style&index=0&id=7c654cdc&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c654cdc"]])

export default __exports__